import Axios from "axios";
import { getBaseApiUrl } from "../constants/base-urls";

Axios.defaults.baseURL = getBaseApiUrl();

export async function getBinaryKey(cardId?: string) {
    return Axios.get(`/api/v1/saltoSpace/getBinaryKey/${cardId}`)
}